// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import ElementUI, { Loading } from 'element-ui';
import { sync } from 'vuex-router-sync';
import StickyTable from 'element-ui-sticky-table';
import vco from 'v-click-outside';
import Vue2TouchEvents from 'vue2-touch-events';
import VueEasyLightbox from 'vue-easy-lightbox';
import posthog from 'posthog-js';
import VueLazyload from 'vue-lazyload';
import initAxiosPlugins from './plugins/axios';

// Scss
import 'element-ui/lib/theme-chalk/index.css';
import '@mdi/font/scss/materialdesignicons.scss';
import 'glightbox/dist/css/glightbox.min.css';
import './assets/app.scss';

import App from './App';
import router from './router';
import store from './store';
import i18n from './i18n';
import InformationFetchingError from './components/InformationFetchingError';
import Status from './components/Status';
import HorizontalLoading from './components/HorizontalLoading';

// Plugins
import './plugins/highcharts';
import './helpers/mixins/global';
import 'vue-multi-ref';

// General Plugins
Vue.config.productionTip = false;
initAxiosPlugins();
Vue.use(ElementUI, { size: 'mini', i18n: (key, value) => i18n.t(key, value) });
sync(store, router);
Vue.use(vco); // from https://www.npmjs.com/package/v-click-outside
Vue.use(Vue2TouchEvents, {
  longTapTimeInterval: 250
});
Vue.use(VueEasyLightbox);
Vue.use(VueLazyload, {
  preLoad: 1.3,
  loading: '/statics/loading_image.svg',
  error: '/statics/erased_image.png',
  attempt: 2,
  observer: true
});

if (!window.location.href.includes('localhost')) {
  posthog.init('phc_uXOtnfb6vDm0zdQalaMOCw6m0IVqmwPSIdeBfy7Mdh0', { api_host: 'https://app.posthog.com' });
} else if (!window.location.href.includes('localhost') && window.location.href.includes('mobile')) {
  // Generate random number 0 to 9
  const randomNumber = Math.floor(Math.random() * 10);

  // Log 10% of requests to posthog in embedded reports
  if (randomNumber === 0) {
    posthog.init('phc_uXOtnfb6vDm0zdQalaMOCw6m0IVqmwPSIdeBfy7Mdh0', { api_host: 'https://app.posthog.com' });
  }
}

// Filters

// credit to @Bill Criswell for this filter
Vue.filter('truncate', (text = '', stop, clamp) => text.slice(0, stop) + (stop < text.length ? clamp || '...' : ''));

// Register general component
Vue.component('InformationFetchingError', InformationFetchingError);
Vue.component('HorizontalLoading', HorizontalLoading);
Vue.component('Status', Status);
Vue.component('sticky-table', StickyTable); // from https://www.npmjs.com/package/element-ui-sticky-table

const loading = Loading.service({
  lock: true,
  text: 'Loading... Please keep your browser open'
});

const mountApp = () => {
  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    router,
    store,
    i18n,
    components: { App },
    template: '<App/>'
  });
};

store.dispatch('setupApplication')
  .then(() => {
    loading.close();
    mountApp();
  })
  .catch(() => {
    loading.close();
    mountApp();
  });
